import { useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { useVerifyClientUpdateIndependentOfCategoryQuery } from "../../../../../redux/services/helpdeskApi";
import { getHelpdeskLabels } from "../../../../../utils/constants/mappings";

export const NO_HELPDESK_UPDATE_PERMISSION_MESSAGE =
  `You do not have permission to update this ${getHelpdeskLabels().ticketSingularLower}`;

export const hasHelpdeskCategoryUpdateAccess = (
  access: string[] | null | undefined
): boolean => Array.isArray(access) && access.length > 0;

export const resolveHelpdeskUpdateAccess = (
  access: string[] | null | undefined,
  isClientUpdateIndependent: boolean | undefined,
  ticketCategory?: string
): boolean => {
  if (isClientUpdateIndependent === true) return true;
  if (ticketCategory) {
    return Array.isArray(access) && access.includes(ticketCategory);
  }
  return hasHelpdeskCategoryUpdateAccess(access);
};

export const useHasHelpdeskUpdateAccess = (
  ticketCategory?: string,
  ticketCreatedById?: string
): boolean => {
  const { data } = useVerifyClientUpdateIndependentOfCategoryQuery();
  const access = useSelector(
    (state: RootState) => state?.auth?.user?.helpdesk_category_update_access
  );
  const currentUserId = useSelector(
    (state: RootState) => state?.auth?.user?._id
  );
  const isTicketCreator =
    !!ticketCreatedById && ticketCreatedById === currentUserId;
  return (
    isTicketCreator || resolveHelpdeskUpdateAccess(access, data, ticketCategory)
  );
};

export const useHelpdeskUpdateAccessChecker = (): ((
  ticketCategory?: string
) => boolean) => {
  const { data } = useVerifyClientUpdateIndependentOfCategoryQuery();
  const access = useSelector(
    (state: RootState) => state?.auth?.user?.helpdesk_category_update_access
  );
  const isClientUpdateIndependent = data;

  return useCallback(
    (ticketCategory?: string) =>
      resolveHelpdeskUpdateAccess(
        access,
        isClientUpdateIndependent,
        ticketCategory
      ),
    [access, isClientUpdateIndependent]
  );
};
